module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/schedule_03-8f907bf8f1930a8acbfdc7fe00130f96.jpg";